import { PromiseClient } from 'hub-http/adapters/promiseClient';

import { ObjectTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import Value from 'customer-data-objects/property/Value';
import {
  GetObjectResponse,
  PropertyValue,
} from 'inbounddb-objects-service-types/InboundDbObjects-Service-v1/types';

import { getOwnProperty } from '../utils/getOwnProperty';

export function fetchPropertyValue(
  httpClient: PromiseClient,
  objectTypeId: ObjectTypeId,
  objectId: string,
  propertyName: string
): Promise<Value> {
  return httpClient
    .get<GetObjectResponse>(
      `inbounddb-objects/v1/crm-objects/${objectTypeId}/${objectId}?properties=${propertyName}`
    )
    .then(
      (response) =>
        getOwnProperty(
          response.properties as Record<string, PropertyValue>,
          propertyName
        )?.value
    )
    .catch((error) => {
      throw error;
    });
}
